import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { isJwtExpired } from '@/lib/auth/jwt';
import { refreshSessionFromCookie } from '@/lib/auth/session';
import { getSafeInternalRedirect } from '@/lib/router/navigation';
import { useAuthStore } from '@/stores/auth';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/login')({
  validateSearch: zodValidator(loginSearchSchema),
  beforeLoad: async ({ search }) => {
    const accessToken = useAuthStore.getState().accessToken;

    if (accessToken && !isJwtExpired(accessToken)) {
      throw redirect({
        href: getSafeInternalRedirect(search.redirect) ?? '/dashboard',
        replace: true,
      });
    }

    const refreshedToken = await refreshSessionFromCookie();
    if (refreshedToken && !isJwtExpired(refreshedToken)) {
      throw redirect({
        href: getSafeInternalRedirect(search.redirect) ?? '/dashboard',
        replace: true,
      });
    }
  },
  component: LoginRouteLayout,
});

function LoginRouteLayout() {
  return <Outlet />;
}
